import React from "react";
import style from "./ErrorFallback.module.css";

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div
      role={"alert"}
      className={style.errorBlock}
    >
      <div className={style.errorWrapper}>
        <p>{'Error'}</p>
        <button onClick={resetErrorBoundary}>{'Reset'}</button>
      </div>
    </div>
  );
}

export default ErrorFallback;
